/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/activo'

export default {
    get: params => {
        let customRoute = `${route}?expand=responsables,grupo,tipo,categoria,status_description&search=${params.filter}`
        switch (params.activoEstado) {
            case "2": customRoute = `${route}?estado=1&expand=responsables,grupo,tipo,categoria,status_description&search=${params.filter}`
                break;
            case "3": customRoute = `${route}?estado=0&expand=responsables,grupo,tipo,categoria,status_description&search=${params.filter}`
                break;
            case "4": customRoute = `${route}?${params.customfilter}&expand=responsables,grupo,tipo,categoria,status_description&search=${params.filter}`//activos del dia
                break;
            case "5": customRoute = `${route}?${params.customfilter}&expand=responsables,grupo,tipo,categoria,status_description&search=${params.filter}`//activos bajas del dia
                break;
            case "6": customRoute = `${route}?${params.customfilter}&expand=responsables,grupo,tipo,categoria,status_description&search=${params.filter}`
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    post: payload => Api().post(`${route}?expand=responsables,grupo,tipo,categoria,status_description`, payload),
    put: payload => Api().post(`${route}/${payload.get('id')}?expand=responsables,departamento,campus,seccion,grupo,tipo,estadoa,categoria,edificio,area,empleado,imagen,status_description`, payload), //porque tiene foto
    getHistory: payload => Api().get(`${route}/${payload.id}?expand=responsables,grupo,tipo,categoria,status_description,history`, { crossDomain: true }),
    delete: payload => Api().delete(`${route}/${payload.id}?expand=responsables,grupo,tipo,categoria,status_description`),
    loadDetails: payload => Api().get(`${route}/${payload.id}?expand=responsables,departamento,campus,seccion,grupo,tipo,estadoa,categoria,edificio,area,empleado,imagen,status_description`, { crossDomain: true }),
    getAllRecords: () => Api().get(`${route}?fields=id,descripcion&expand=status_description`, { crossDomain: true })
}
